import { ApiError } from '../../api/client';

/** Same 403/400/fallback idiom `invoice-api-errors.ts`'s `genericApiErrorMessage` already applies. */
function genericApiErrorMessage(error: ApiError): string {
  if (error.status === 403) {
    return 'No tenés permiso para realizar esta acción.';
  }

  if (error.status === 400) {
    return 'Revisá los datos ingresados e intentá de nuevo.';
  }

  return 'Ocurrió un error inesperado. Intentá de nuevo.';
}

/** Codes from `FiscalConfigExceptionFilter` (`apps/api` `fiscal-config-exception.filter.ts`). */
export function mapArcaConfigError(error: unknown): string {
  if (error === undefined || error === null) {
    return '';
  }

  if (!(error instanceof ApiError)) {
    return 'Ocurrió un error de conexión. Intentá de nuevo.';
  }

  const code = (error.body as { code?: string } | null)?.code;

  if (error.status === 422 && code === 'ISSUER_CUIT_INVALID_CHECK_DIGIT') {
    return 'El CUIT del emisor no tiene un dígito verificador válido.';
  }

  if (error.status === 422 && code === 'ISSUER_DATA_INCOMPLETE') {
    return 'Faltan datos obligatorios del emisor.';
  }

  if (error.status === 422 && code === 'FISCAL_SECRETS_KEY_MISSING') {
    return 'No se puede generar la clave por un problema de configuración del sistema. Contactá a soporte.';
  }

  if (error.status === 422 && code === 'CERTIFICATE_CSR_NOT_GENERATED') {
    return 'Todavía no generaste la clave y el CSR para este ambiente.';
  }

  if (error.status === 422 && code === 'CERTIFICATE_INVALID_PEM') {
    return 'El archivo subido no es un certificado PEM válido.';
  }

  if (error.status === 422 && code === 'CERTIFICATE_KEY_MISMATCH') {
    return 'El certificado no corresponde a la clave generada para este ambiente.';
  }

  if (error.status === 422 && code === 'CERTIFICATE_CUIT_MISMATCH') {
    return 'El CUIT del certificado no coincide con el CUIT del emisor configurado.';
  }

  if (error.status === 422 && code === 'PRODUCTION_CHECKLIST_INCOMPLETE') {
    return 'El checklist "Qué falta" todavía no está completo.';
  }

  if (error.status === 422 && code === 'PRODUCTION_CERTIFICATE_MISSING_OR_EXPIRED') {
    return 'El certificado de Producción falta o está vencido.';
  }

  if (error.status === 422 && code === 'PRODUCTION_CONNECTION_TEST_STALE') {
    return 'Repetí "Probar conexión" contra Producción: la última prueba exitosa tiene más de 24 horas.';
  }

  if (error.status === 422 && code === 'PRODUCTION_CUIT_CONFIRMATION_MISMATCH') {
    return 'El CUIT ingresado no coincide con el CUIT configurado del emisor.';
  }

  return genericApiErrorMessage(error);
}
